﻿
import angular from 'angular';

import './cart-product-confirm';
import './checkout-newsletter';
import '../../../services/cart';
import '../../../services/mailchimp';
import '../../../services/user';
import '../../../services/payment';

angular.module('folkeuni').component('confirm', {
  bindings: {
    cart: '=',
    state: '<',
    siteId: '<'
  },
    controller: function (Mailchimp, PaymentService, $location, $timeout, Cart, $q, User) {
    var $ctrl = this;
    $ctrl.currentUser = null;
    $ctrl.ErrorTimer = null;
    $ctrl.personDataCustomerLink = "/om-folkeuniversitetet/folkeuniversitetets-persondatapolitik-for-deltagere/";
    $ctrl.salesAndDeliveryLink = "/til-deltagere/salgs-og-leveringsbetingelser/";
    $ctrl.showNewsletterSubscription = false;
    $ctrl.spamLock = false;

    function checkout() {
      var deferred = $q.defer();

            $ctrl.cart.checkout.students = [];

            $ctrl.cart.products.forEach((product) => {
                product.discount.forEach((discount) => {
                    if (discount.type == "Student") {
                        $ctrl.cart.checkout.students.push({
                            id: discount.id,
                            place: discount.place,
                            number: discount.number
                        });
                    }
                });
            });
            $ctrl.cart.checkout.tickets = $ctrl.cart.tickets;
            var sentCheckout = JSON.parse(JSON.stringify($ctrl.cart.checkout));
            if (sentCheckout.customer && sentCheckout.customer.phoneNumber) {
                sentCheckout.customer.phoneNumber = sentCheckout.customer.phoneNumber.toString();
            }
            Cart.checkout(sentCheckout).then(function (checkout) {
                deferred.resolve(checkout);
            }, function (res) {
                deferred.reject(res);
            });

            return deferred.promise;
        };

        function paymentWindow() {

            if ($ctrl.cart.checkout.siteId != "0") {
                checkout().then(function (checkout) {
                    if (checkout.skipPayment) {
                        window.location = checkout.url;
                    } else {
                        PaymentService.openPaymentWindow(checkout);
                    }
                }, function (errorStuff) {
                    if (errorStuff.status == 400) {
                        $ctrl.termsError = errorStuff.data;
                        $ctrl.ErrorTimer = $timeout(function () { $ctrl.termsError = null }, 5000);
                    } else {
                        $ctrl.termsError = "Der skete en fejl og du stilles videre til din kurv.";
                        $ctrl.ErrorTimer = $timeout(function () {
                            $location.path('cart');
                            $ctrl.termsError = null
                        }, 2500);
                    }
                });
            }
            else {
                $ctrl.termsError = "Der er sket en teknisk fejl, så vi beder dig bekræfte din data. (Du bliver stillet videre om 2 sekunder)";
                $ctrl.ErrorTimer = $timeout(function () {
                    $location.path('cart');
                    $ctrl.termsError = null
                }, 2500);
            }
        }

        $ctrl.back = function () {
            $location.path('delivery');
        };

        $ctrl.activateSpamLock = () => {
            $ctrl.spamLock = true;
            setTimeout(() => {
                $ctrl.spamLock = false;
            }, 10000);
        }

        $ctrl.next = () => {
            $ctrl.termsError = null;
            if (!$ctrl.spamLock) {
                $ctrl.activateSpamLock();
                $timeout.cancel($ctrl.ErrorTimer);
                if ($ctrl.cart.acceptTerms) {
                    $ctrl.termsError = null;
                    var acceptNewsletter = false;

                    var subscriberObj = {
                        email_address: $ctrl.cart.checkout.customer.email,
                        interests: {}
                    };

                    for (let i = 0; i < $ctrl.cart?.newsletter?.length; i++) {
                        const currentInterest = $ctrl.cart.newsletter[i];

                        for (let y = 0; y < currentInterest.options.length; y++) {
                            const currentOption = currentInterest.options[y];

                            subscriberObj.interests[currentOption.id] = currentOption.selected;
                            if (currentOption.selected) {
                                acceptNewsletter = true;
                            }
                        }
                    }

                    if ($ctrl.cart.checkout.customer.createUser) {
                        var newUser = {
                            email: ($ctrl.cart.checkout.customer.email != null ? $ctrl.cart.checkout.customer.email : ""),
                            firstName: ($ctrl.cart.checkout.customer.firstName != null ? $ctrl.cart.checkout.customer.firstName : ""),
                            middleName: ($ctrl.cart.checkout.customer.middleName != null ? $ctrl.cart.checkout.customer.middleName : ""),
                            lastName: ($ctrl.cart.checkout.customer.lastName != null ? $ctrl.cart.checkout.customer.lastName : ""),
                            streetName: ($ctrl.cart.checkout.customer.streetName != null ? $ctrl.cart.checkout.customer.streetName : ""),
                            streetNumber: ($ctrl.cart.checkout.customer.streetNumber != null ? $ctrl.cart.checkout.customer.streetNumber : ""),
                            floorNumber: ($ctrl.cart.checkout.customer.floorNumber != null ? $ctrl.cart.checkout.customer.floorNumber : ""),
                            side: ($ctrl.cart.checkout.customer.side != null ? $ctrl.cart.checkout.customer.side : ""),
                            roomNumber: ($ctrl.cart.checkout.customer.roomNumber != null ? $ctrl.cart.checkout.customer.roomNumber : ""),
                            phoneNumber: ($ctrl.cart.checkout.customer.phoneNumber != null ? $ctrl.cart.checkout.customer.phoneNumber.toString() : ""),
                            postalCode: ($ctrl.cart.checkout.customer.postalCode != null ? $ctrl.cart.checkout.customer.postalCode : ""),
                            city: ($ctrl.cart.checkout.customer.city != null ? $ctrl.cart.checkout.customer.city : ""),
                            country: ($ctrl.cart.checkout.customer.countryObj.code != null ? $ctrl.cart.checkout.customer.countryObj.code : ""),
                            password: ($ctrl.cart.checkout.customer.password != null ? $ctrl.cart.checkout.customer.password : ""),
                            confirmPassword: ($ctrl.cart.checkout.customer.confirmPassword != null ? $ctrl.cart.checkout.customer.confirmPassword : "")
                        };
                        newUser.siteId = $ctrl.siteId;

                        User.create(newUser).then(function (successResponse) {
                        if ($ctrl.signUpForNewsletter && acceptNewsletter) {
                            Mailchimp.subscribe($ctrl.siteId, subscriberObj).then(function (successResponse) {
                                paymentWindow();
                            }, function () { });
                        }
                        else {
                            paymentWindow();
                        }
                    }, function () {
                        if ($ctrl.signUpForNewsletter && acceptNewsletter) {
                            Mailchimp.subscribe($ctrl.siteId, subscriberObj).then(function (successResponse) {
                                paymentWindow();
                            }, function () { });
                        }
                        else {
                            paymentWindow();
                        }
                    });
                }
                else {
                    if ($ctrl.signUpForNewsletter && acceptNewsletter) {
                        Mailchimp.subscribe($ctrl.siteId, subscriberObj).then(function (successResponse) {
                            paymentWindow();
                        }, function () { });
                    }
                    else {
                        paymentWindow();
                    }
                }
            } else {
                $ctrl.termsError = "Du skal acceptere vores salgs- og leveringsbetingelser for at gennemføre din bestilling. Vores betingelser står i toppen af denne side.";
                $ctrl.ErrorTimer = $timeout(function () { $ctrl.termsError = null }, 5000);
            }
        }
        };

        $ctrl.$onInit = function () {
            if ($ctrl.cart.checkout) {
                Mailchimp.getSubscriber($ctrl.siteId, $ctrl.cart.checkout.customer.email).then(function (user) {
                    if (user.statusCode === undefined) {
                        $ctrl.hasNewsletterToday = true;
                    }
                });
            }



            for (var i = 0; i < $ctrl.cart.products.length; i++) {
                var currentProduct = $ctrl.cart.products[i];
                if (!(currentProduct.typeId == 23 && $ctrl.siteId == 1)) {
                    $ctrl.showNewsletterSubscription = true;
                    break;
                }
            }

            if ($ctrl.siteId == 3) {
                $ctrl.personDataCustomerLink = "/om-folkeuniversitetet/folkeuniversitetets-persondatapolitik-for-deltagere/";
                $ctrl.salesAndDeliveryLink = "/tilmelding";
            }
            else if ($ctrl.siteId == 15) {
                $ctrl.personDataCustomerLink = "/om-folkeuniversitetet/folkeuniversitetets-persondatapolitik-for-deltagere/";
                $ctrl.salesAndDeliveryLink = "/tilmelding-betaling/salgs-og-leveringsbetingelser";
            }
            if ($ctrl.cart && $ctrl.cart.checkout && $ctrl.cart.checkout.company) {
                $ctrl.paymentTypeLabel = Cart.paymentMethodGetByValue($ctrl.cart.checkout.company.paymentType).label;
            }
            if($ctrl.cart && $ctrl.cart.checkout){
                $ctrl.cart.checkout.siteId = $ctrl.siteId;
            }
        }
    },
    templateUrl: '/shop-dist/templates/confirm.html?c=' + window.cacheBurst+1,
    transclude: true
});
